import axios from 'axios';
import endpoint from 'endpoint';

export default {
  findNearBankOffices: async (projectId, zipCode) => {
    return axios.get(`${endpoint.REACT_APP_SCHEDULING_ENDPOINT}/v1/bank-offices/near?projectId=${projectId}&zipCode=${zipCode}`);
  },
}
